// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"SocialMediaContact_fieldWrapper__hEitL","icon":"SocialMediaContact_icon__7Egl7","text":"SocialMediaContact_text__do7Gz"};